import { Injectable } from "@angular/core";
import { Actions, createEffect, ofType } from "@ngrx/effects";
import { Store } from "@ngrx/store";
import { of } from "rxjs";
import { catchError, mergeMap, withLatestFrom, map, filter } from "rxjs/operators";
import { BankState } from "../state/bank.state";
import { BankService } from "../../services/bank.service";
import * as BankActions from "../actions/bank.actions";
import * as BankSelectors from "../selectors/bank.selectors";
import * as ErrorActions from "../../../shared/store/actions/error.actions";
import * as LoaderActions from "../../../shared/store/actions/loader.actions";

@Injectable()
export class BankEffects {
    constructor(
        private actions$: Actions,
        private bankService: BankService,
        private store: Store<BankState>
    ) { }

    getBankCountries$ = createEffect(() => {
        return this.actions$.pipe(
            ofType(BankActions.GetBankCountries),
            map(action => action.supplierCode),
            mergeMap((supplierCode: string) => {
                //  Increment loader count
                this.store.dispatch(new LoaderActions.IncrementLoaderCount());

                return this.bankService.getBankCountries(supplierCode).pipe(
                    map(countries => {
                        //  Dispatch action to decause load count & return new success action
                        this.store.dispatch(new LoaderActions.DecrementLoaderCount());
                        return BankActions.GetBankCountriesSuccess({ supplierCode, countries });
                    }),
                    catchError(err => {
                        //  Dispatch action to decause load count & return new error action
                        this.store.dispatch(new LoaderActions.DecrementLoaderCount());
                        return of(new ErrorActions.PushError(err));
                    })
                )
            })
        )
    });
}